import { createSlice } from '@reduxjs/toolkit';
import { LeasingOffer, LeasingOfferStatus } from 'modules/types/LeasingOffer';
import { fetchLeasingOffers } from './thunks';

export interface LeasingOffersState {
  loading: boolean;
  leasingOffers?: LeasingOffer[];
  status?: LeasingOfferStatus;
  totalPageCount?: number;
  error?: string;
  page?: number;
}

const initialState: LeasingOffersState = {
  error: undefined,
  leasingOffers: undefined,
  status: undefined,
  loading: true,
  totalPageCount: 1,
  page: 1,
};

export const leasingOffersSlice = createSlice({
  name: 'leasingOffers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLeasingOffers.pending, (state) => {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.leasingOffers = initialState.leasingOffers;
      state.status = initialState.status;
      state.totalPageCount = initialState.totalPageCount;
      state.page = initialState.page;
    });
    builder.addCase(fetchLeasingOffers.fulfilled, (state, action) => {
      state.leasingOffers = action.payload.leasingOffers;
      state.status = action.payload.status;
      state.totalPageCount = action.payload.totalPageCount;
      state.loading = false;
      state.page = action.payload.page;
    });
    builder.addCase(fetchLeasingOffers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });
  },
});

export default leasingOffersSlice.reducer;
